import { render, staticRenderFns } from "./vet.vue?vue&type=template&id=63ab0365&scoped=true&"
import script from "./vet.vue?vue&type=script&lang=js&"
export * from "./vet.vue?vue&type=script&lang=js&"
import style0 from "./vet.vue?vue&type=style&index=0&id=63ab0365&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab0365",
  null
  
)

export default component.exports